module.exports = __webpack_public_path__ + "assets/images/earn-rewards/user-example-2.b232e33fb3e610ee2a8094a19514b469.webp";